<template>
  <welfare-detail :is-create="false" />
</template>

<script>
import WelfareDetail from './detail'
export default {
  name: 'EditWelfare',
  components: { WelfareDetail }
}
</script>
